import React from "react";

// ASSETS
import { ReactComponent as Folder } from "assets/svg/Folder.svg";

// STYLES
import {
  Antet,
  CardWrapper,
  DownloadButtonWrapper,
  MiddleContent,
  MobileWrapper,
  SvgWrapper,
} from "./DownloadFileAtomStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC
import { IProps, DownloadFileType } from "./DownloadFileAtomModel";
import { TextType } from "../CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { ButtonType } from "../ButtonAtom/ButtonAtomModel";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";
import { selectLanguage } from "slices/LanguageSlice/languageSlice";

// COMPONENTS
import CustomText from "../CustomText/CustomText";
import ButtonAtom from "../ButtonAtom/ButtonAtom";

const DownloadFileAtom = (props: IProps) => {
  // PROPERTIES
  const {
    type = DownloadFileType.Orders,
    title = "",
    documentType = "",
    institution = "",
    date = "",
    pdfUrl = "",
    description = "",
  } = props;

  // LIBRARY CONSTANTS
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const selectedLanguage = useSelector(selectLanguage);
  const { t } = useTranslation();

  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  const formatDateToDDMMYYYY = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}.${month}.${year}`;
  };

  const formatDateToMonthDD = (date) => {
    const d = new Date(date);
    const day = d.getDate();
    const locale = selectedLanguage === "ro" ? "ro-RO" : "en-US";
    let month = d.toLocaleString(locale, { month: "long" });
    month = month.charAt(0).toUpperCase() + month.slice(1);

    return `${month} ${day}`;
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(pdfUrl);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = pdfUrl.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  return (
    <CardWrapper type={type}>
      <MobileWrapper>
        <SvgWrapper>
          <Folder />
        </SvgWrapper>
        <MiddleContent>
          <Antet>
            <CustomText
              text={institution}
              type={TextType.H5bold}
              color={COLORS.VividAuburn}
            />
            <CustomText
              text={
                type === DownloadFileType.Orders
                  ? formatDateToDDMMYYYY(date)
                  : documentType
              }
              type={TextType.H6}
              color={COLORS.MetalicSilver}
            />
          </Antet>
          <CustomText
            text={
              type === DownloadFileType.Orders
                ? title
                : type === DownloadFileType.Dialogue
                ? description
                : formatDateToMonthDD(date)
            }
            type={TextType.H5}
          />
        </MiddleContent>
      </MobileWrapper>
      <DownloadButtonWrapper biggerCursor={biggerCursor}>
        <ButtonAtom
          type={
            type === DownloadFileType.Dialogue
              ? ButtonType.ArrowDownRed
              : ButtonType.ArrowDownDefault
          }
          text={t("components.downloadFile.download")}
          arrowDown={true}
          rightIcon={true}
          onClick={handleDownload}
        />
      </DownloadButtonWrapper>
    </CardWrapper>
  );
};

export default DownloadFileAtom;
